import { render, staticRenderFns } from "./PayablePage.vue?vue&type=template&id=6632451f&scoped=true"
import script from "./PayablePage.vue?vue&type=script&lang=js"
export * from "./PayablePage.vue?vue&type=script&lang=js"
import style0 from "./PayablePage.vue?vue&type=style&index=0&id=6632451f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6632451f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6632451f')) {
      api.createRecord('6632451f', component.options)
    } else {
      api.reload('6632451f', component.options)
    }
    module.hot.accept("./PayablePage.vue?vue&type=template&id=6632451f&scoped=true", function () {
      api.rerender('6632451f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/feeInfoTab/components/PayablePage.vue"
export default component.exports